import React, { FC } from 'react';
import { useRouteMatch } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';

import { Layouts } from 'components';
import * as paths from 'paths';
import * as Containers from './containers';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
}));

const PostController: FC = () => {
  const classes = useStyles();
  const match = useRouteMatch();

  let main = null;
  switch (match.path) {
    case paths.postCreate:
      main = <Containers.PostCreate />;
      break;
    case paths.postEdit:
      main = <Containers.PostContentLoader />;
      break;
    default:
      throw new Error('Unhandled Post Route');
  }

  return (
    <div className={classes.root}>
      <Layouts.App1Column desktopSize={8} main={main} />
    </div>
  );
};

export default PostController;
